import * as React from 'react';
import { SVGProps } from 'react';

const SvgAmbulancia = (props: SVGProps<SVGSVGElement>) => (
  <svg width={32} height={34} viewBox="0 0 32 34" fill="none" role="img" {...props}>
    <path
      d="M10.26 1c-.982 0-1.797.733-1.923 1.68l-1.802.502a3.455 3.455 0 0 0-2.49 3.892c.494 3.001 2.078 8.08 7.134 11.23.086-.399.258-.765.493-1.087-4.57-2.924-6.01-7.572-6.463-10.333a2.279 2.279 0 0 1 1.648-2.566l1.688-.471A1.941 1.941 0 1 0 10.26 1Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.075 2.44a2.244 2.244 0 0 1 4.432.5v.002a2.241 2.241 0 0 1-4.101 1.255l-1.469.41a1.98 1.98 0 0 0-1.432 2.228c.447 2.723 1.861 7.272 6.33 10.13l.268.172-.188.258a2.56 2.56 0 0 0-.443.972l-.09.417-.361-.226C5.859 15.342 4.25 10.162 3.75 7.123a3.755 3.755 0 0 1 2.705-4.23l1.62-.452ZM10.26 1.3c-.83 0-1.519.62-1.626 1.42l-.026.195-1.992.556a3.155 3.155 0 0 0-2.274 3.555c.476 2.894 1.975 7.712 6.661 10.808.068-.185.153-.363.253-.53C6.782 14.305 5.363 9.68 4.913 6.932a2.579 2.579 0 0 1 1.863-2.904l1.921-.536.113.214c.276.521.824.876 1.455.876A1.641 1.641 0 1 0 10.26 1.3Z"
      fill="currentColor"
    />
    <path
      d="M16.353 17.299c.222.326.38.701.457 1.104 5.188-3.141 6.794-8.292 7.292-11.329a3.461 3.461 0 0 0-2.49-3.892l-1.701-.476A1.94 1.94 0 0 0 17.983 1a1.941 1.941 0 1 0 1.706 2.87l1.607.448a2.283 2.283 0 0 1 1.647 2.566c-.461 2.788-1.923 7.495-6.59 10.415Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.741 2.942a2.241 2.241 0 0 1 4.434-.473l1.518.424a3.761 3.761 0 0 1 2.705 4.23c-.504 3.075-2.137 8.33-7.432 11.537l-.37.223-.08-.424c-.07-.362-.212-.7-.41-.991l-.176-.258.264-.166c4.56-2.853 5.998-7.458 6.453-10.208a1.983 1.983 0 0 0-1.431-2.23l-1.391-.387a2.241 2.241 0 0 1-4.084-1.277ZM17.983 1.3a1.641 1.641 0 1 0 1.443 2.425l.115-.208 1.835.512a2.583 2.583 0 0 1 1.864 2.903v.001c-.46 2.776-1.903 7.465-6.477 10.46.093.171.172.352.234.54 4.808-3.091 6.329-7.978 6.81-10.907a3.161 3.161 0 0 0-2.275-3.555l-1.895-.53-.024-.2a1.64 1.64 0 0 0-1.63-1.441Z"
      fill="currentColor"
    />
    <path
      d="M24.68 20.476a3.114 3.114 0 0 0-.61 6.17v.474a4.712 4.712 0 0 1-4.707 4.708 4.712 4.712 0 0 1-4.708-4.707v-5.414c-.217.05-.439.082-.674.082-.172 0-.34-.014-.502-.046v5.373A5.89 5.89 0 0 0 19.363 33a5.89 5.89 0 0 0 5.884-5.884v-.466a3.116 3.116 0 0 0 2.552-3.064 3.12 3.12 0 0 0-3.118-3.11Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.267 23.59a3.414 3.414 0 0 1 3.414-3.414 3.42 3.42 0 0 1 3.418 3.409 3.416 3.416 0 0 1-2.552 3.305v.226a6.19 6.19 0 0 1-6.184 6.184 6.19 6.19 0 0 1-6.184-6.184V21.38l.357.069c.14.027.289.04.445.04.208 0 .407-.028.607-.074l.367-.084v5.79a4.412 4.412 0 0 0 4.408 4.407 4.412 4.412 0 0 0 4.407-4.407v-.239a3.418 3.418 0 0 1-2.503-3.292Zm3.414-2.814a2.814 2.814 0 0 0-.552 5.575l.24.048v.722a5.012 5.012 0 0 1-5.006 5.007 5.012 5.012 0 0 1-5.008-5.007v-5.056a3.035 3.035 0 0 1-.577.018v5.033a5.59 5.59 0 0 0 5.585 5.584 5.59 5.59 0 0 0 5.584-5.584V26.4l.245-.045a2.816 2.816 0 0 0 2.307-2.769 2.82 2.82 0 0 0-2.818-2.81Z"
      fill="currentColor"
    />
    <path
      d="M15.914 18.915a1.93 1.93 0 0 0-1.928-1.929 1.93 1.93 0 0 0-1.929 1.928 1.93 1.93 0 0 0 1.929 1.929c1.063 0 1.928-.86 1.928-1.928Z"
      fill="currentColor"
    />
    <path d="M26 23.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="#fff" />
  </svg>
);

export default SvgAmbulancia;
